if (!customElements.get('songsong-catalog')) {
customElements.define('songsong-catalog', class extends HTMLElement {
 connectedCallback() {
  this.controller?.abort();this.controller = new AbortController();const signal=this.controller.signal;
  this.results=this.querySelector('[data-catalog-results]');this.select=this.querySelector('[data-catalog-sort]');
  this.typeSelect=this.querySelector('[data-catalog-type]');
  this.original=[...this.querySelectorAll('.ss-gallery-card')];
  this.select?.addEventListener('change',()=>{if(this.dataset.source==='manual')this.sortManual();else this.load(this.dataset.collectionUrl);},{signal});
  this.typeSelect?.addEventListener('change',()=>{if(this.dataset.source==='manual')this.sortManual();else this.load(this.dataset.collectionUrl);},{signal});
  this.addEventListener('click',e=>{const link=e.target.closest('.ss-pagination a');if(link&&this.contains(link)&&this.dataset.source!=='manual'){e.preventDefault();this.load(link.href);}},{signal});
 }
 disconnectedCallback(){this.controller?.abort();this.request?.abort();}
 sortManual(){
  const key=this.select?.value||'manual',cards=[...this.original];
  if(key.startsWith('price-'))cards.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
  if(key.startsWith('title-'))cards.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title));
  if(key.endsWith('descending'))cards.reverse();
  const grid=this.querySelector('.ss-page-products');cards.forEach(c=>{c.hidden=!!this.typeSelect?.value&&c.dataset.productType!==this.typeSelect.value;grid.append(c);});
  const status=this.querySelector('[data-catalog-status]');status.hidden=cards.some(c=>!c.hidden);status.textContent=this.dataset.empty;
 }
 async load(href){
  if(!href)return;this.request?.abort();const request=new AbortController();this.request=request;
  const url=new URL(href,location.origin);if(this.select)url.searchParams.set('sort_by',this.select.value);
  if(this.typeSelect?.value)url.searchParams.set('filter.p.product_type',this.typeSelect.value);else url.searchParams.delete('filter.p.product_type');
  url.searchParams.set('view','songsong-grid-'+this.dataset.pageSize);
  const preview=new URL(location.href).searchParams.get('preview_theme_id');
  if(preview)url.searchParams.set('preview_theme_id',preview);
  else if(window.Shopify?.designMode&&window.Shopify?.theme?.id)url.searchParams.set('preview_theme_id',window.Shopify.theme.id);
  const status=this.querySelector('[data-catalog-status]');status.hidden=true;this.results.setAttribute('aria-busy','true');
  try{
   const response=await fetch(url,{signal:request.signal});if(!response.ok)throw new Error('HTTP '+response.status);
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');const feed=doc.querySelector('[data-catalog-feed]');
   if(!feed)throw new Error('Missing catalog');if(request.signal.aborted)return;
   this.results.innerHTML=feed.innerHTML;
   const empty=this.results.querySelector('[data-catalog-empty]');if(empty)empty.textContent=this.dataset.empty;
   this.results.querySelectorAll('.ss-gallery-card__action button').forEach(b=>b.textContent=this.dataset.add);
   this.results.querySelectorAll('.ss-gallery-card__action > a').forEach(b=>b.textContent=this.dataset.options);
   this.results.querySelectorAll('.ss-gallery-card__sold-out').forEach(b=>b.textContent=this.dataset.sold);
  }catch(e){if(e.name!=='AbortError'){status.textContent=this.dataset.error;status.hidden=false;}}
  finally{if(this.request===request)this.results.removeAttribute('aria-busy');}
 }
});
}
